export const UTM_DEFAULT_SOURCE = "directo";
export const UTM_DEFAULT_MEDIUM = "landing_mkt";
export const UTM_DEFAULT_CAMPAIGN = "hyundai";

function getSearchParams() {
  if (typeof window === "undefined") return new URLSearchParams();
  return new URLSearchParams(window.location.search);
}

function storageGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

/** True si en la query actual no hay utm_source, utm_medium ni utm_campaign (tras trim). */
export function urlSinUtmsPrincipales(query = getSearchParams()) {
  const s = query.get("utm_source")?.trim();
  const m = query.get("utm_medium")?.trim();
  const c = query.get("utm_campaign")?.trim();
  return !s && !m && !c;
}

export function getUtmParams() {
  const query = getSearchParams();

  if (urlSinUtmsPrincipales(query)) {
    return {
      utm_source: UTM_DEFAULT_SOURCE,
      utm_medium: UTM_DEFAULT_MEDIUM,
      utm_campaign: UTM_DEFAULT_CAMPAIGN,
    };
  }

  const pick = (key, def) => {
    const fromUrl = query.get(key)?.trim();
    if (fromUrl) return fromUrl;
    const fromSt = storageGet(key)?.trim();
    if (fromSt) return fromSt;
    return def;
  };

  const utm_source = pick("utm_source", UTM_DEFAULT_SOURCE) || UTM_DEFAULT_SOURCE;
  const utm_medium = pick("utm_medium", UTM_DEFAULT_MEDIUM) || UTM_DEFAULT_MEDIUM;
  const utm_campaign = pick("utm_campaign", UTM_DEFAULT_CAMPAIGN) || UTM_DEFAULT_CAMPAIGN;

  const utUrl = query.get("utm_term")?.trim();
  const utSt = storageGet("utm_term")?.trim();
  const utm_term = utUrl || utSt || undefined;

  const out = { utm_source, utm_medium, utm_campaign };
  if (utm_term) out.utm_term = utm_term;
  return out;
}

export function saveUtmParams() {
  if (typeof window === "undefined") return;
  const query = getSearchParams();

  if (urlSinUtmsPrincipales(query)) {
    sessionStorage.setItem("utm_source", UTM_DEFAULT_SOURCE);
    sessionStorage.setItem("utm_medium", UTM_DEFAULT_MEDIUM);
    sessionStorage.setItem("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    sessionStorage.removeItem("utm_term");
    return;
  }

  ["utm_source", "utm_medium", "utm_campaign", "utm_term"].forEach((key) => {
    const v = query.get(key);
    if (v != null && String(v).trim() !== "") {
      sessionStorage.setItem(key, v);
    }
  });
}

export function getCurrentUrlWithUtmDefaults() {
  if (typeof window === "undefined") return "";
  const u = new URL(window.location.href);
  const q = u.searchParams;

  if (urlSinUtmsPrincipales(q)) {
    q.set("utm_source", UTM_DEFAULT_SOURCE);
    q.set("utm_medium", UTM_DEFAULT_MEDIUM);
    q.set("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    q.delete("utm_term");
    return u.toString();
  }

  if (!q.get("utm_source")?.trim()) {
    q.set("utm_source", storageGet("utm_source")?.trim() || UTM_DEFAULT_SOURCE);
  }
  if (!q.get("utm_medium")?.trim()) {
    q.set("utm_medium", storageGet("utm_medium")?.trim() || UTM_DEFAULT_MEDIUM);
  }
  if (!q.get("utm_campaign")?.trim()) {
    q.set("utm_campaign", storageGet("utm_campaign")?.trim() || UTM_DEFAULT_CAMPAIGN);
  }

  return u.toString();
}

export function buildUtmQueryString() {
  const { utm_source, utm_medium, utm_campaign, utm_term } = getUtmParams();
  const parts = [
    `utm_source=${encodeURIComponent(utm_source)}`,
    `utm_medium=${encodeURIComponent(utm_medium)}`,
    `utm_campaign=${encodeURIComponent(utm_campaign)}`,
  ];
  if (utm_term) parts.push(`utm_term=${encodeURIComponent(utm_term)}`);
  return `?${parts.join("&")}`;
}
